import { useState } from 'react'

import { formatDate, getInitialDates, parseInputDate } from '../helpers'

const useDateRange = rangeValue => {
  const [startDate, setStartDate] = useState(getInitialDates(rangeValue).startDate)
  const [endDate, setEndDate] = useState(getInitialDates(rangeValue).endDate)
  const [inputValues, setInputValues] = useState({ startDate: formatDate(startDate), endDate: formatDate(endDate) })

  const onChangeDate = dates => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
    setInputValues({ startDate: formatDate(start), endDate: formatDate(end) })
  }

  const handleChangeInputDate = (event, dateType) => {
    const value = event.target.value
    setInputValues({ ...inputValues, [dateType]: value })

    const parsedDate = parseInputDate(value)

    if (!isNaN(parsedDate?.getTime())) {
      if (dateType === 'startDate') {
        setStartDate(parsedDate)
      } else {
        setEndDate(parsedDate)
      }
    }
  }

  const resetDateRange = () => {
    setStartDate(null)
    setEndDate(null)
    setInputValues({ startDate: '', endDate: '' })
  }

  return {
    startDate,
    endDate,
    inputValues,
    onChangeDate,
    handleChangeInputDate,
    resetDateRange,
  }
}

export default useDateRange
